import React from 'react';

const TermsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">
            Allgemeine Geschäftsbedingungen – Online-Kurs „KI-Kompetenznachweis nach EU AI Act"
          </h1>
          
          <div className="prose max-w-none text-gray-600">
            <p className="text-sm text-gray-500 mb-8">Stand: Mai 2025</p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">1 Geltungsbereich</h2>
            <p>
              Diese AGB gelten ausschließlich für den Erwerb und die Nutzung der Online‑Schulung 
              „KI‑Kompetenznachweis nach EU AI Act" der <strong>KI Navigatoren GmbH</strong> 
              (nachfolgend „Anbieter") gegenüber ihren Kunden („Nutzer").
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2 Vertragsgegenstand</h2>
            <p>
              Der Anbieter gewährt Zugang zu video­basierten Lernmodulen, einem abschließenden 
              Online‑Test sowie – bei Bestehen – einem personalisierten Zertifikat.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">3 Vertragsschluss</h2>
            <ol className="list-decimal pl-5 space-y-2">
              <li>Die Kursdarstellung ist ein unverbindliches Angebot.</li>
              <li>Mit Klick auf <strong>„Jetzt kostenpflichtig buchen"</strong> gibt der Nutzer ein verbindliches Angebot ab.</li>
              <li>Der Vertrag kommt mit Freischaltung des Nutzer­kontos zustande.</li>
            </ol>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">4 Preise & Zahlung</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li>Kursgebühr gemäß aktueller Preisübersicht des Anbieters.</li>
              <li>Zahlung via Stripe (Kreditkarte) oder Rechnung (14 Tage).</li>
              <li>Voucher‑Codes gewähren Rabatte laut Konditionen.</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">5 Leistungserbringung</h2>
            <p>
              Nach Zahlungseingang wird der Kursbereich sofort freigeschaltet. Der Test kann beliebig 
              oft wiederholt werden, bis ≥ 75 % erreicht sind. Zertifikat wird automatisiert als PDF 
              bereitgestellt.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">6 Pflichten des Nutzers</h2>
            <p>
              Zugangsdaten vertraulich behandeln; Inhalte nur für eigene Lernzwecke nutzen.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">7 Widerrufsrecht (Verbraucher)</h2>
            <p>
              Verbraucher haben 14 Tage Widerrufsrecht (§ 312g BGB). <strong>Das Recht erlischt</strong>, 
              wenn der Nutzer ausdrücklich verlangt, dass der Anbieter vor Ablauf der Frist mit der 
              Ausführung beginnt und der Kurs vollständig freigeschaltet wurde (§ 356 Abs. 5 BGB).
            </p>
            <p className="italic mt-2">
              Checkbox-Hinweis im Checkout: „Ich verlange ausdrücklich, dass die KI Navigatoren GmbH i.G. 
              sofort mit der Ausführung beginnt und weiß, dass ich dadurch mein Widerrufsrecht verliere."
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">8 Haftung</h2>
            <p>
              Unbeschränkte Haftung bei Vorsatz/grober Fahrlässigkeit; bei einfacher Fahrlässigkeit nur 
              für wesentliche Vertragspflichten, begrenzt auf den typischen Schaden.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">9 Urheberrecht</h2>
            <p>
              Kursvideos, Unterlagen, Zertifikate sind urheberrechtlich geschützt. Unbefugte Weitergabe 
              verboten.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">10 Laufzeit & Kündigung</h2>
            <p>
              Zugang gilt 12 Monate; ordentliche Kündigung während dieser Laufzeit ausgeschlossen. 
              Kündigung aus wichtigem Grund bleibt möglich.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">11 Datenschutz</h2>
            <p>
              Es gilt die aktuelle{' '}
              <a href="/datenschutz" className="text-blue-600 hover:text-blue-800">
                Datenschutzerklärung
              </a>.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">12–15</h2>
            <p className="italic">
              (reserviert für weitere Leistungsanlagen)
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">16 Erfüllungsort, Gerichtsstand</h2>
            <ol className="list-decimal pl-5 space-y-2">
              <li>
                Ist der Kunde Kaufmann, ist der Geschäftssitz des Anbieters Gerichtsstand; der Anbieter 
                kann den Kunden auch an dessen Wohnsitzgericht verklagen.
              </li>
              <li>
                Es gilt ausschließlich deutsches Recht; UN‑Kaufrecht ist ausgeschlossen.
              </li>
              <li>
                Sofern die Auftragsbestätigung nichts anderes regelt, ist der Geschäftssitz des Anbieters 
                Erfüllungsort.
              </li>
              <li>
                Sollte eine Bestimmung unwirksam sein, bleibt der Vertrag im Übrigen wirksam; anstelle 
                der unwirksamen Bestimmung gilt eine wirksame, die dem wirtschaftlichen Zweck am nächsten 
                kommt.
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;